export default {
  ACTIVE_STATIONS_STATUS: ['INSTALLED', 'OPERATIONAL'],
  STATIONS_STATUS: [
    'CREATED',
    'INSTALLED',
    'OPERATIONAL',
    'MAINTENANCE',
    'ARCHIVED',
  ],
  ACTIVE_STATIONS_STATUS_FOR_INSTALLER: ['CREATED', 'MAINTENANCE'],
  STATIONS_STATUS_FOR_INSTALLER: [
    'CREATED',
    'INSTALLED',
    'OPERATIONAL',
    'MAINTENANCE',
  ],
  STATIONS_STATUS_FOR_INSTALLER_TO_WRITE: [
    'CREATED',
    'INSTALLED',
    'MAINTENANCE',
  ],
  STATIONS_STATUS_FOR_STANDARD: ['INSTALLED', 'OPERATIONAL', 'MAINTENANCE'],
  STATIONS_STATUS_ENUM: {
    CREATED: 'CREATED',
    INSTALLED: 'INSTALLED',
    OPERATIONAL: 'OPERATIONAL',
    MAINTENANCE: 'MAINTENANCE',
    ARCHIVED: 'ARCHIVED',
  },
  STATUS_ENUM: {
    CREATED: 'CREATED',
    ARCHIVED: 'ARCHIVED',
  },
  USERS_ROLES: [20, 30, 90],
  USERS_ROLES_AS_INT: { 20: 20, 30: 30, 90: 90 },
  IS_USER_ROLE_STANDARD: {
    20: true,
    30: false,
    90: false,
  },
  IS_USER_ROLE_INSTALLER: {
    20: false,
    30: true,
    90: false,
  },
  IS_USER_ROLE_ADMIN: {
    20: false,
    30: false,
    90: true,
  },
  USERS_ROLES_STRING_ENUM: {
    ADMIN: 'ADMIN',
    INSTALLER: 'INSTALLER',
    STANDARD: 'STANDARD',
  },
  USERS_ROLES_AS_STRING: {
    90: 'ADMIN',
    30: 'INSTALLER',
    20: 'STANDARD',
  },
};
